import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-submit-solid",
  "use": "icon-submit-solid-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-submit-solid\"><path d=\"m29.4 17-24 10.2c-.8.4-1.6-.4-1.4-1.2l2-8 14-2-13.8-2L4 6c-.2-.8.6-1.6 1.4-1.2l24 10.2c.8.4.8 1.6 0 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol